import { addYears } from 'date-fns';

import { MultiGroupEventsCollection } from '@/modules/events/MultiGroupEventsCollection';

interface Props {
  className?: string;
}

export const NewsEventsCollection = ({ className }: Props) => {
  const eventsToDate = addYears(new Date(), 1);
  const startOfDay = new Date();
  startOfDay.setUTCHours(0, 0, 0, 0);

  return (
    <MultiGroupEventsCollection
      groupIds={[]}
      title="Upcoming events"
      emptyTitle="No upcoming events"
      from={startOfDay}
      to={eventsToDate}
      includeOngoing={true}
      className={className}
    />
  );
};
